import absurd from 'common/absurd';
import * as React from 'react';
import CheckFilled from 'src/icons/CheckFilled';
import MinusFilled from 'src/icons/MinusFilled';

const size = '16px';

export type Value = 'empty' | 'minus' | 'check';
type Props = {
  value: Value;
  onClick?: () => void;
  onShiftClick?: () => void;
};

const iconFill = 'var(--color-primary-foreground)';

const renderValue = (value: Value): React.ReactNode => {
  switch (value) {
    case 'minus':
      return <MinusFilled width={size} height={size} fill={iconFill} />;
    case 'check':
      return <CheckFilled width={size} height={size} fill={iconFill} />;
    case 'empty':
      return <div className="size-4 bg-background" />;
    default:
      absurd(value);
  }
};

const Base = (props: Props) => {
  const handleChange = (e: React.MouseEvent<HTMLElement>) => {
    if (e.shiftKey) {
      props.onShiftClick && props.onShiftClick();
    } else {
      props.onClick && props.onClick();
    }
    e.stopPropagation();
  };
  return (
    <div
      className="size-4 cursor-pointer overflow-hidden rounded-[5px] bg-primary m-0.5 shadow-[0_1px_1px_0_rgb(0_0_0/12%),0_0_0_1px_rgb(64_68_82/16%),0_2px_5px_0_rgb(64_68_82/8%)]"
      onClick={handleChange}
    >
      {renderValue(props.value)}
    </div>
  );
};

export default Base;
